import styled from "styled-components";

export const TrackingContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 20px;
    max-width: 90vw;
    margin: 0 auto;
    background-color: #f9f9f9;
    border-radius: 10px;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
`;

export const SearchWrapper = styled.div`
    display: flex;
    flex-direction: row;
    gap: 10px;
    margin-bottom: 20px;
    width: 100%;
`;

export const Input = styled.input`
    flex: 1;
    padding: 10px;
    font-size: 16px;
    border: 1px solid #ccc;
    border-radius: 5px;

    &:focus {
        border-color: #007bff;
        outline: none;
    }
`;

export const Button = styled.button`
    padding: 10px 15px;
    background-color: #007bff;
    color: white;
    border: none;
    border-radius: 5px;
    cursor: pointer;

    &:hover {
        background-color: #0056b3;
    }
`;

export const UserDetails = styled.div`
    width: 100%;
    margin-top: 20px;
`;

export const Table = styled.table`
    width: 100%;
    border-collapse: collapse;
`;

export const TableRow = styled.tr`
    border-bottom: 1px solid #ccc;
`;

export const TableCell = styled.td`
    padding: 10px;
    text-align: left;
    font-size: 16px;
`;

export const Status = styled.span`
    font-weight: bold;
    color: ${({ status }) => (status === "paid" ? "green" : status === "pending" ? "orange" : "red")};
`;

export const Heading = styled.h2`
    margin-bottom: 20px;
    text-align: center;
    color: #333;
`;

export const StepWrapper = styled.div`
    width: 100%;
    text-align: center;
`;
